import { render, staticRenderFns } from "./CoreValuesOneIcon.vue?vue&type=template&id=1a9536d3&"
import script from "./CoreValuesOneIcon.vue?vue&type=script&lang=js&"
export * from "./CoreValuesOneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports